import React, { useEffect } from "react";
import "./Categories.css";
import { Link, useNavigate } from "react-router-dom";
import { useProductStore } from "../../stores/useProductStores";
import { useImageStore } from "../../stores/useImageStores";

const Categories = () => {
  const { getProductsByCategory } = useProductStore();
  const { imagesByCategory, getImagesByCategory } = useImageStore();
  const navigate = useNavigate();

  // Fetch each category image separately
  useEffect(() => {
    getImagesByCategory("category");          // Banner
    getImagesByCategory("category-coords");   // Co-ords
    getImagesByCategory("category-dresses");  // Dresses
  }, [getImagesByCategory]);

  // Safely get images from the store
  const bannerImage =
    imagesByCategory?.["category"]?.[0]?.image_url || "/images/placeholder-banner.png";

  const coordsImage =
    imagesByCategory?.["category-coords"]?.[0]?.image_url || "/images/placeholder-coords.png";

  const dressesImage =
    imagesByCategory?.["category-dresses"]?.[0]?.image_url || "/images/placeholder-dresses.png";

  // Click handler
  const handleCategoryClick = async (category) => {
    if (!category) return; // safety check
    await getProductsByCategory(category);
    navigate(`/${category}`);
  };

  return (
    <div className="categories-container">
      {/* Banner Section */}
      <div className="banner-category">
        <img
          src={bannerImage}
          alt="Categories Banner"
          className="banner-image"
           loading="lazy"
           decoding="async"
        />
        <div className="banner-text">
          <p>EXPLORE OUR COLLECTION</p>
        </div>
      </div>

      {/* Small Categories Section */}
      <div className="categories-smaller">
        <Link to="/co-ords" className="category">
          <img
            src={coordsImage}
            alt="Co-ords"
            className="category-image"
            onClick={() => handleCategoryClick("co-ords")}
             loading="lazy"
             decoding="async"
          />
          <h2 className="category-text">CO-ORDS</h2>
        </Link>

        <Link to="/dresses" className="category">
          <img
            src={dressesImage}
            alt="Dresses"
            className="category-image"
            onClick={() => handleCategoryClick("dresses")}
             loading="lazy"
             decoding="async"
          />
          <h2 className="category-text">DRESSES</h2>
        </Link>
      </div>
    </div>
  );
};

export default Categories;
